import type { ReactNode } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { pageTransition, pageTransitionConfig } from '../theme/animations';

interface PageTransitionProps {
  children: ReactNode;
  /**
   * Unique key for the page (typically the route path)
   * This tells AnimatePresence when to trigger exit/enter animations
   */
  pageKey?: string;
}

/**
 * PageTransition Component
 *
 * Wraps page content with Framer Motion animations for smooth page transitions.
 * Uses the global pageTransition variant from theme/animations.ts
 *
 * Usage:
 * ```tsx
 * <PageTransition pageKey={location.pathname}>
 *   <YourPageContent />
 * </PageTransition>
 * ```
 */
export function PageTransition({ children, pageKey }: PageTransitionProps) {
  return (
    <AnimatePresence>
      <motion.div
        key={pageKey}
        initial="initial"
        animate="animate"
        exit="exit"
        variants={pageTransition}
        transition={pageTransitionConfig}
        style={{ width: '100%' }}
      >
        {children}
      </motion.div>
    </AnimatePresence>
  );
}
